import i18next from 'i18next';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { usePlans } from '../../api/hooks/usePlans';
import { StandaloneFeatureType } from '../../interfaces/enumerables';
import { PATHS } from '../../navigation/data';
import { selectSelectedCompany } from '../../store/companies/companiesSlice';
import { setToast } from '../../store/core/coreSlice';
import { store } from '../../store/store';

interface ActiveFeatureResult {
  enabled: boolean;
  isChecking: boolean;
}

export const useHasActiveFeature = (featureId: StandaloneFeatureType, redirectHome = false): ActiveFeatureResult => {
  const company = useSelector(selectSelectedCompany);
  const { data, isLoading, isSuccess, isError } = usePlans(company?.vatNumber || '');
  const navigate = useNavigate();

  const redirectHomeAction = useCallback((msg: string) => {
    navigate(PATHS.HOME, { replace: true });
    store.dispatch(
      setToast({
        value: {
          show: true,
          msg: i18next.t(msg),
          isError: true,
          duration: 30000,
        },
      }),
    );
  }, []);

  useEffect(() => {
    if (isSuccess && redirectHome && !data?.activeFeatures?.[featureId]) {
      redirectHomeAction('PLANS.NO_ACTIVE_PLAN_FOR_FEATURE');
    }
  }, [isSuccess, redirectHome, data, featureId, redirectHomeAction]);

  // Something is off with the server => let user use the app
  if (isError) return { enabled: true, isChecking: false };

  return {
    enabled: isLoading || (data?.activeFeatures?.[featureId] ?? false),
    isChecking: isLoading,
  };
};
